var map = {
	"./contacts-email-icon.png": 8150,
	"./footer-sportscape-icon.png": 4452,
	"./home-desktop.png": 6109,
	"./home-logos.png": 9076,
	"./home-phone-1.png": 6357,
	"./home-phone-2.png": 126,
	"./home-tablet.png": 4408,
	"./slider-1.jpg": 8848,
	"./slider-10.jpg": 1282,
	"./slider-2.jpg": 4275,
	"./slider-3.jpg": 9985,
	"./slider-4.jpg": 6654,
	"./slider-5.jpg": 5271,
	"./slider-6.jpg": 4184,
	"./slider-7.jpg": 6321,
	"./slider-8.jpg": 9115,
	"./slider-9.jpg": 1149,
	"./sportscape-white-primary-logo.svg": 2928,
	"./stats-sportscape-bg-icon-small.png": 9916,
	"./stats-sportscape-bg-icon.png": 8569,
	"./stats-sportscape-icon.png": 7247,
	"./welcome-bg-mobile.jpg": 1760,
	"./welcome-bg.jpg": 7432,
	"./welcome-full-stop.svg": 4647
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5459;